<div class="opciones">
    <div class="col-md-12">
        <p>
            Elija la opción hacia donde quiere ir.
        </p>
    </div>
    <div class="col-md-12">
        <a target="_blank" [href]="filedomSolicitudUrl">

            <button mat-raised-button color="primary">Solicitud de Certificados</button>
        </a>
        <!-- <button mat-raised-button color="primary" (click)="sign()">Expedientes en linea</button> -->
    </div>
    <!-- <div *ngIf="!seguimientoCertificados" class="col-md-12" style="padding-top: 10px;">
        <a target="_blank" [href]="filedomSeguimientoUrl">
            <button mat-raised-button color="primary">Seguimiento de Certificados</button>
        </a>
    </div> -->
    <div class="col-md-12" style="padding-top: 10px;">
        <button mat-raised-button color="primary" (click)="sign('seg-certificados')">Seguimiento de Certificados
        </button>
    </div>
</div>